import sprites from '../sprites.js'
import Actor from './Actor.js'
import {randItem} from "../utils";

const VARIANTS = ['airBallSmall', 'airBallBig']

export default class AirObstacle extends Actor {
	// pixels that are added/removed to `y` when switching between wings up and wings down
	constructor(imageData, type) {
		super(imageData)
		this.spriteFrames = 0
		this.spriteDirection = '1'
		this.type = type === undefined ? randItem(VARIANTS) : type
		this.sprite = `${this.type}${this.spriteDirection}`
		// these are dynamically set by the game
		this.x = null
		this.y = null
		this.speed = null
		this.wingsRate = null
		this.maxAirObstacleHeight = Math.max(sprites[this.type + 1].h, sprites[this.type + 2].h) / 2
	}

	nextFrame() {
		this.x -= this.speed
		this.determineSprite()
	}

	determineSprite() {
		if (this.spriteFrames >= this.wingsRate) {
			this.spriteDirection = this.spriteDirection === '1' ? '2' : '1'
			this.spriteFrames = 0
		}

		this.sprite = `${this.type}${this.spriteDirection}`
		this.spriteFrames++
	}
}
